import { render, staticRenderFns } from "./CreatePermitMemoModal.vue?vue&type=template&id=b27a7368&"
import script from "./CreatePermitMemoModal.vue?vue&type=script&lang=js&"
export * from "./CreatePermitMemoModal.vue?vue&type=script&lang=js&"
import style0 from "./CreatePermitMemoModal.vue?vue&type=style&index=0&id=b27a7368&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports